import React from "react";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import "./style.css";

export function ModalConfirmacao({ isOpen, toggle, onConfirmar, children }) {
  return (
    <Modal
      className="text-center"
      isOpen={isOpen}
      toggle={toggle}
      backdrop={false}
    >
      <ModalHeader
        toggle={toggle}
        className="campanha-premiacao-confirmacao-header"
      />
      <ModalBody>
        <p className="campanha-premiacao-confirmacao-texto">{children}</p>
      </ModalBody>
      <div className="m-3">
        <Button
          onClick={() => toggle()}
          color="danger"
          className="campanha-premiacao-confirmacao-botao campanha-premiacao-confirmacao-cancelar"
        >
          Cancelar
        </Button>
        <Button
          onClick={() => onConfirmar()}
          className="campanha-premiacao-confirmacao-botao campanha-premiacao-confirmacao-confirmar"
        >
          Confirmar
        </Button>
      </div>
    </Modal>
  );
}
